<div *ngIf="isMedication">
    <div class="medication-row-compact" *ngIf="mode == 'compact'" cdkDrag>
        <div style="position:relative;">
            <div style="float:left;" class="row-icons" matTooltip="Modifier le traitement" matTooltipPosition="above"><fa-icon (click)="editMedication()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon></div>
            <div style="float:left;" matTooltip="Traitement chronique" matTooltipPosition="above"><fa-icon *ngIf="chronic" (click)="toggleChronic()" [icon]="['fas', 'clock']" [ngClass]="{'medication-chronic': chronic, 'medication-nochronic': !chronic}" size="lg"></fa-icon></div>
            <div style="float:left;" matTooltip="Traitement à risque" matTooltipPosition="above"><fa-icon *ngIf="risk" (click)="toggleRisk()" [icon]="['fas', 'exclamation-triangle']" [ngClass]="{'medication-risk': risk, 'medication-norisk': !risk}" size="lg"></fa-icon></div>
            <div style="float:right;">{{ startDate }}</div> 
        </div>
        <div style="clear:both;">{{ record.value }}</div>
    </div>
    <div class="medication-row-full" [ngClass]="{'medication-finished-row': active}"  *ngIf="mode == 'full'">
        <div class="flex-container medication-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <div fxFlex="80px">
                <div>
                    <div class="flex-container medication-row-icons" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                        <fa-icon (click)="editMedication()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon>
                        <fa-icon (click)="openAccess()" [icon]="['fas', 'user-lock']" class="access-icon" size="lg"></fa-icon>
                    </div>
                </div>
                <div class="row-date">{{ startDate }}</div>
                <div class="row-date">{{ endDate }}</div>
            </div>
            <div fxFlex="25px">
                <fa-icon *ngIf="chronic" (click)="toggleChronic()" [icon]="['fas', 'clock']" [ngClass]="{'medication-chronic': chronic, 'medication-nochronic': !chronic}" size="lg"></fa-icon>
            </div>
            <div fxFlex="25px">
                <fa-icon *ngIf="risk" (click)="toggleRisk()" [icon]="['fas', 'exclamation-triangle']" [ngClass]="{'medication-risk': risk, 'medication-norisk': !risk}" size="lg"></fa-icon>
            </div>
            <div fxFlex="grow">
                <div class="medication-content" [innerHtml]="content | crToBr | safeHtml"></div>
            </div>
            <div class="medication-posorow" fxFlex="264px" fxLayout="row">
                <div *ngFor="let posoIndex of ['1','2','3','4','5','6','7','8','9','10','11','12']" fxFlex="22px" class="medication-poso">
                    {{ poso(posoIndex) }}
                </div>    
            </div>
            <div fxFlex="350px">
                <div class="medication-comment" [innerHtml]="comment | crToBr | safeHtml"></div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isTreatment">
    <div class="medication-row-compact" *ngIf="mode == 'compact'" cdkDrag>
        <div style="position:relative;">
            <div style="float:left;" class="row-icons" matTooltip="Modifier le traitement" matTooltipPosition="above"><fa-icon (click)="editTreatment()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon></div>
            <div style="float:left;" class="row-icons"><fa-icon [icon]="medications.typeIcon(record.type)" size="lg"></fa-icon></div>
            <div style="float:right;">{{ startDate }} -> {{ endDate }}</div>
        </div>
        <div style="clear:both;"></div>
        <div *ngIf="record.type == 'Kine'" class="session-steps-container">
            <div class="session-steps-bar">
                <div *ngFor="let session of sessions" class="session-step-indicator" [ngClass]="{'session-step-indicator-done': session}"></div>
            </div>
            <div class="session-description">{{ record.description }}</div>
        </div>
        <div *ngIf="record.type == 'Logo'" class="session-steps-container">
            <div class="session-steps-bar session-steps-bar-logo">
                <div [ngStyle]="logoProgressBarStyle()"></div>
            </div>
            <div class="session-description">{{ record.description }}</div>
        </div>
    </div>
    <div class="medication-row-full" [ngClass]="{'medication-finished-row': active}"  *ngIf="mode == 'full'">
        <div class="flex-container medication-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <div fxFlex="80px">
                <div>
                    <div class="flex-container medication-row-icons" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                        <fa-icon (click)="editTreatment()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon>
                        <fa-icon (click)="openAccess()" [icon]="['fas', 'user-lock']" class="access-icon" size="lg"></fa-icon>
                        <fa-icon [icon]="medications.typeIcon(record.type)" size="lg"></fa-icon>
                    </div>
                </div>
                <div class="row-date">{{ startDate }}</div>
                <div class="row-date">{{ endDate }}</div>
            </div>
            <div *ngIf="record.type == 'Kine'" fxFlex="grow" class="session-steps-container">
                <div class="session-steps-bar">
                    <div *ngFor="let session of sessions" class="session-step-indicator" [ngClass]="{'session-step-indicator-done': session}"></div>
                </div>
                <div class="treatment-description">
                    <div class="medication-content" [innerHtml]="record.description | crToBr | safeHtml"></div>
                </div>
            </div>
            <div *ngIf="record.type == 'Logo'" fxFlex="grow" class="session-steps-container">
                <div class="session-steps-bar session-steps-bar-logo">
                    <div [ngStyle]="logoProgressBarStyle()"></div>
                </div>
                <div>
                    <div class="medication-content" [innerHtml]="record.description | crToBr | safeHtml"></div>
                </div>
            </div>
        </div>
    </div>
</div>